/*
  When a user navigates to a specific project page
  Given the data is loaded
  Then they will be presented with data about the project
  When a user clicks "claim" on the project
  Then they will claim the project as one they want to contribute to
*/

//Packages
import React, { useEffect, useState } from "react";
import axios from "axios";
//Components
import MapContainer from "../../components/MapContainer";
import { useParams, Link } from "react-router-dom";
//Material UI Components
import { Grid, Typography, Button, Stack, Avatar, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
//API Route
import { Route } from "../../utils/config";
//Animation
import { motion } from "framer-motion";
import InfoRow from "./InfoRow";
//Context
import { userContext } from "../../Context";
import { useContext } from "react";

//Material UI Styles
const useStyles = makeStyles({
  infoRow: {
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "#7070702d solid 2px",
    paddingTop: 15,
    paddingBottom: 15,
  },
  claimBox: {
    position: "absolute",
    zIndex: 1,
    top: 25,
    left: 25,
    width: 175,
    height: 175,
    borderRadius: 25,
    backgroundColor: "#FFFFFF",
  },
  link: {
    textDecoration: "none",
    color: "#052442",
  },
});

export default function Project() {
  const styles = useStyles();
  const { id } = useParams();

  const { user } = useContext(userContext);

  const [project, setProject] = useState({
    project: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const getProject = (id) => {
    axios
      .get(`${Route}/Projects/GetProjectDisplayView`, {
        params: {
          projectId: id,
        },
      })
      .then((res) => {
        setProject(res.data);
        setLocations([
          {
            lat: res.data.latitude,
            lng: res.data.longitude,
            id: res.data.id,
            name: res.data.name,
            overview: res.data.overview,
          },
        ]);
        setIsLoading(false);
      })
      .catch((err) => {
        throw err;
      });
  };

  useEffect(() => {
    getProject(id);
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className={styles.root}>
        <Grid container justifyContent="center" color="#052442">
          <Grid container item md={6} justifyContent="center">
            <Grid item mt={2} mb={2} xs={10} sm={9}>
              <Typography variant="body2" color="#8898AA">
                HOME <span styles={"color: black"}>/</span> EXPLORE
                <span styles={"color: black"}> / PROJECTS</span>
              </Typography>
            </Grid>

            <Grid item xs={10} sm={9} mb={2}>
              <Stack spacing={1}>
                <Typography
                  variant="h6"
                  fontWeight="400"
                  fontSize={{ md: "34px" }}
                >
                  {project.name}
                </Typography>
                <Typography fontSize="14px" color="#58585A">
                  Project # {project.id} | Created by {project.primaryPartner}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={10} sm={9} mb={2}>
              <Stack spacing={1}>
                <Typography variant="body1">Project Overview:</Typography>
                <Typography fontSize="14px" color="#58585A">
                  {project.overview ? project.overview : "No project overview"}
                </Typography>
              </Stack>
            </Grid>

            <Grid item xs={10} sm={9} mb={2}>
              <Stack spacing={1}>
                <Typography variant="body1">Project Type:</Typography>
                <Grid container spacing={0.5}>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ cursor: "auto" }}
                    >
                      {project.projectType ? project.projectType : "No data"}
                    </Button>
                  </Grid>
                </Grid>
              </Stack>
            </Grid>

            <Grid
              container
              item
              xs={10}
              sm={9}
              mb={2}
              justifyContent="space-between"
            >
              <InfoRow label="Country" data={project.country}></InfoRow>
              <InfoRow label="Region" data={project.region}></InfoRow>
              <InfoRow
                label="# of Beneficients"
                data={project.benifactorCount}
              ></InfoRow>
              <InfoRow
                label="Project Status"
                data={project.projectStatus}
              ></InfoRow>
              <InfoRow
                label="Year Completed"
                data={project.yearBuilt}
              ></InfoRow>
              <InfoRow label="Built By" data={project.primaryPartner}></InfoRow>
              {/* <InfoRow
                label="Quality of Project"
                data={project.projectQuality}
              ></InfoRow> */}
              <Grid
                container
                item
                className={styles.infoRow}
                justifyContent="space-between"
              >
                <Grid container item xs={2} sm={1} justifyContent="center">
                  <Avatar></Avatar>
                </Grid>
                <Grid
                  container
                  item
                  xs={10}
                  md={6}
                  justifyContent="space-around"
                >
                  <Grid
                    item
                    xs={9}
                    sm={6}
                    overflow="hidden"
                    textOverflow="ellipsis"
                  >
                    <Typography fontSize="15px">
                      {project.primaryPartner}
                    </Typography>
                  </Grid>
                  <Grid item fontSize="12px">
                    <Link
                      to={`/partner/${project.primaryPartnerId}`}
                      className={styles.link}
                    >
                      View
                    </Link>
                  </Grid>
                </Grid>
                <Grid
                  container
                  item
                  justifyContent={{ xs: "center", md: "flex-end" }}
                  mt={{ xs: 2 }}
                  sm={12}
                  md={5}
                >
                  <a
                    href="mailto:mark@lovebig.org"
                    style={{
                      textDecoration: "none",
                      color: "white",
                      background: "#052442",
                      borderRadius: "50px",
                      padding: "6px 16px",
                    }}
                  >
                    Ask a question?
                  </a>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={11} sm={9} md={5}>
            <Box
              position="relative"
              height={{ xs: "300px", md: "100vh" }}
              borderRadius="25px"
              overflow="hidden"
              mb={2}
            >
              <Box
                className={styles.claimBox}
                display={{ xs: "none", md: "block" }}
              >
                <Grid container height="100%" p={2} alignItems="space-between">
                  <Grid item xs={8}>
                    {" "}
                    <Typography fontSize="20px">Claim this project</Typography>
                  </Grid>
                  <Grid container item alignItems="flex-end">
                    <Button color="primary" variant="contained">
                      <Link
                        to={
                          user.role === "" ||
                          user.role === "Support" ||
                          user.role === null
                            ? "/join"
                            : `/claim/${id}`
                        }
                        state={{ id: id }}
                        style={{
                          color: "#FFFFFF",
                          textDecoration: "none",
                        }}
                      >
                        Claim Project
                      </Link>
                    </Button>
                  </Grid>
                </Grid>
              </Box>

              {!isLoading ? (
                <MapContainer
                  locations={locations}
                  radius={project.radius}
                  center={{ lat: project.latitude, lng: project.longitude }}
                  region="af"
                  zoomLevel={8}
                  disableHover={false}
                ></MapContainer>
              ) : (
                <></>
              )}
            </Box>

            {user.role === "" ||
            user.role === "Support" ||
            user.role === undefined ? (
              ""
            ) : (
              <Grid item mb={2} display={{ md: "none" }}>
                <Button size="large" variant="contained" color="neutral">
                  Claim This Project
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </div>
    </motion.div>
  );
}
